import { render, staticRenderFns } from "./OpenQuestionBtn.vue?vue&type=template&id=421c0432&scoped=true&"
import script from "@/scripts/QA/Question/components/OpenQuestionBtn?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/OpenQuestionBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c0432",
  null
  
)

export default component.exports